"use strict";
/*
 * Created on 12 28 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Base implementation of {@link IProductSupplier}.
 * You can directly use this as key of immutable collections (set, map, ...).
 *
 * @author JMe
 */


var ProductSupplier =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSupplier, _DomainObject_1$Domai);

  /**
   * @param productId {@link IProductSupplier.productId}
   * @param supplierId {@link IProductSupplier.supplierId}, internal id
   */
  function ProductSupplier(productId, supplierId) {
    var _this;

    _classCallCheck(this, ProductSupplier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSupplier).call(this));
    _this.productId = productId;
    _this.supplierId = supplierId;
    return _this;
  }

  _createClass(ProductSupplier, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductSupplier) {
        var otherKey = other;
        return this.productId === otherKey.productId && this.supplierId === otherKey.supplierId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.productId, ":").concat(this.supplierId));
    }
  }]);

  return ProductSupplier;
}(DomainObject_1.DomainObject);

exports.ProductSupplier = ProductSupplier;